<template>
<div class="is-fullheight is-flex align-center justify-center">
  <div class="auth-box">
    <div class="has-text-centered">
      <logo width="10rem" />
    </div>
    <form class="box">
      <div class="has-text-centered">
        <h3 class="title is-4">Reset Password</h3>
      </div>

      <div class="columns">
        <div class="column">
          <text-input required :error="$root.errors.email" v-model="reset.email">Email</text-input>
        </div>
      </div>
      
      <div class="columns">
        <div class="column">
          <text-input required type="password" :error="$root.errors.password" v-model="reset.password">Password</text-input>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <text-input required type="password" :error="$root.errors.password_confirmation" v-model="reset.password_confirmation">Confirm Password</text-input>
        </div>
      </div>

      <div class="columns">
        <div class="column has-text-centered">
          <submit-button class="is-rounded" :working="working" @submit="performReset">Submit</submit-button>
        </div>
      </div>
    </form>
  </div>
</div>    
</template>
<script>
import { post } from '@/api/request'

export default {
  
  data: () => ({
    loading: true,
    working: false,
    reset: {
      token: '',
      email: '',
      password: '',
      password_confirmation: ''
    }
  }),

  beforeCreate() {
    this.$bus.$emit('set-title', 'Reset Password')
  },


  created() {
    if(this.$route.query.token) {
      this.reset.token = this.$route.query.token
      this.loading = false
    } else {
      this.$router.push({ name: 'signin' })
    }
  },

  methods: {
    performReset() {
      this.working = true
      post('/api/reset-password', this.reset, () => {
        this.working = false
        this.$toast.success('Password successfully reset.')
        this.$router.push({
          name: 'signin'
        })
      }, error => {
        this.working = false
      })
    }
  }

}
</script>